<template>
  <b-card
    no-body
    class="card-browser-states"
  >
    <b-card-header>
      <div>
        <b-card-title>Encuestadores</b-card-title>
      </div>
    </b-card-header>

    <!-- body -->
    <b-card-body>

      <div
        v-for="(encuest,index) in itemsEncuestador"
        :key="encuest.idUsuario"
        class="browser-states"
      >
        <b-media no-body>
          <b-media-aside class="mr-1">
            <b-avatar
              size="32"
              :src="`data:image/jpeg;base64,${encuest.usuario.foto}`"
            />
          </b-media-aside>
          <b-media-body>
            <h6 class="align-self-center my-auto">
              {{ encuest.usuario.nombre }} {{ encuest.usuario.apellidoPaterno }}
            </h6>
          </b-media-body>
        </b-media>
        <div class="d-flex align-items-center">
          <span class="font-weight-bold text-body-heading mr-1">{{ calculatePorcentage(encuest.metaEncuesta, encuest.cantidadEncuestaRealizada) }}</span>
          <vue-apex-charts
            v-if="chartData.length>0"
            type="radialBar"
            height="30"
            width="30"
            :options="chartData[index].options"
            :series="chartData[index].series"
          />
        </div>
      </div>
    </b-card-body>
    <!--/ body -->
  </b-card>
</template>

<script>
// import store from '@/store'
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BMedia, BMediaAside, BMediaBody, BAvatar,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { _ } from 'vue-underscore'
import { getColorsemaforo } from '@/helpers'
import { $themeColors } from '@themeConfig'
/* eslint-disable global-require */
const $trackBgColor = '#e9ecef'
export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    VueApexCharts,
  },
  data() {
    return {
      chartData: [],
      chartClone: {},
      // porcengeFicha: 0,
      chartColor: [$themeColors.danger, $themeColors.warning, $themeColors.primary, $themeColors.info, $themeColors.danger, $themeColors.primary, $themeColors.warning, $themeColors.secondary, $themeColors.info, $themeColors.danger, $themeColors.info, $themeColors.danger, $themeColors.info, $themeColors.danger],
      // chartColor: [$themeColors.danger, $themeColors.warning, $themeColors.secondary],
      // chartSeries: [54.4, 6.1, 14.6, 4.2, 8, 54.4, 6.1, 14.6, 4.2, 8, 5, 12, 79, 54.0, 4.2],
      itemsEncuestador: [],
      chart: {
        series: [],
        options: {
          grid: {
            show: false,
            padding: {
              left: -15,
              right: -15,
              top: -12,
              bottom: -15,
            },
          },
          colors: [$themeColors.primary],
          plotOptions: {
            radialBar: {
              hollow: {
                size: '22%',
              },
              track: {
                background: $trackBgColor,
              },
              dataLabels: {
                showOn: 'always',
                name: {
                  show: false,
                },
                value: {
                  show: false,
                },
              },
            },
          },
          stroke: {
            lineCap: 'round',
          },
        },
      },
    }
  },
  methods: {
    /* async charData() {
      for (let i = 0; i < this.itemsEncuestador.length; i += 1) {
        const chartClone = JSON.parse(JSON.stringify(this.chart))
        chartClone.options.colors[0] = this.chartColor[i]
        chartClone.series[0] = this.chartSeries[i]
        this.chartData.push(chartClone)
      }
    }, */
    async generateListEncuestado(data) {
      if (data !== null) {
        this.itemsEncuestador = data
        this.generateGrafico()
      }
    },
    async generateGrafico() {
      this.chartData = []
      for (let i = 0; i < this.itemsEncuestador.length; i += 1) {
        const chartClone = JSON.parse(JSON.stringify(this.chart))
        const emeta = _.isNull(this.itemsEncuestador[i].metaEncuesta) ? 0 : this.itemsEncuestador[i].metaEncuesta
        const emetaRealizada = _.isNull(this.itemsEncuestador[i].cantidadEncuestaRealizada) ? 0 : this.itemsEncuestador[i].cantidadEncuestaRealizada
        const result = Number(this.calculatePorcentage(emeta, emetaRealizada)) // (datTotal === 0) ? 0 : (emetaRealizada * 100) / datTotal
        // console.log(`${emeta} -  Meta Realizada: ${emetaRealizada} totla en % ${result}`)
        chartClone.options.colors[0] = getColorsemaforo(result) // this.chartColor[color]
        chartClone.series[0] = Number(result)
        this.chartData.push(chartClone)
      }
    },
    getColorsemaforo,
    calculatePorcentage(meta, cantidadEncuestaRealizada) {
      const emeta = _.isNull(meta) ? 0 : meta
      const emetaRealizada = _.isNull(cantidadEncuestaRealizada) ? 0 : cantidadEncuestaRealizada
      const total = (Number(emeta) === 0) ? 0 : ((Number(emetaRealizada) * 100) / Number(emeta)).toFixed(2)
      return total
    },
  },
}
</script>
